export const stripNonDigits = (value: string | number | undefined | null): string => {
  const numericValue = value?.toString().replace(/\D/g, '') || '';
  const withNoNumericChars = numericValue.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, '');

  return withNoNumericChars;
};
